import React, { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';

const PWAInstallBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Check if already dismissed or installed
    const dismissed = localStorage.getItem('pwa-banner-dismissed');
    if (dismissed) return;

    // Only show on mobile devices
    const isMobile = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Check if already installed as PWA
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    // Listen for the beforeinstallprompt event (Android/Desktop Chrome)
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // For iOS Safari, show banner after delay since there's no prompt event
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      const timer = setTimeout(() => setShowBanner(true), 3000);
      return () => { clearTimeout(timer); window.removeEventListener('beforeinstallprompt', handler); };
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowBanner(false);
      }
      setDeferredPrompt(null);
    } else {
      // iOS - show instructions
      alert('Para instalar utentik:\n1. Toca el ícono de Compartir (cuadrado con flecha)\n2. Selecciona "Agregar a Inicio"');
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-banner-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 md:bottom-4 left-4 right-4 z-50 max-w-md mx-auto animate-fade-in" data-testid="pwa-install-banner">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-4 flex items-center gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#22BCB9]/10 flex items-center justify-center">
          <Download className="w-5 h-5 text-[#22BCB9]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm text-gray-500">Instalar utentik</p>
          <p className="text-xs text-gray-400">Acceso rápido desde tu pantalla</p>
        </div>
        <button
          onClick={handleInstall}
          className="flex-shrink-0 px-4 py-2 bg-[#22BCB9] text-white text-sm font-medium rounded-full hover:bg-[#1D9B99] transition-colors"
          data-testid="pwa-install-btn"
        >
          Instalar
        </button>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 rounded-full hover:bg-gray-100"
          data-testid="pwa-dismiss-btn"
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallBanner;
